import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_serialnumbers_grid_ComponentContextService } from './FootprintManager.serialnumbers_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { SerialNumbers_serialnumbers_lots_dd_singleComponent } from './SerialNumbers.serialnumbers_lots_dd_single.component'
import { SerialNumbers_serialnumbers_packagings_dd_singleComponent } from './SerialNumbers.serialnumbers_packagings_dd_single.component'


interface IFootprintManager_serialnumbers_gridComponentEntity {
  Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, NetVolume?: number, NetWeight?: number, Notes?: string, PackagingId?: number, Width?: number, Lot?: { Id?: number, LookupCode?: string, Material?: { Id?: number, Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string }, MaterialGroup?: { Name?: string } }, VendorLot?: { LookupCode?: string } }, LicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, Name?: string, Warehouse?: { Name?: string } }, Type?: { Id?: number, Name?: string } }, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Short_name?: string }, Packaging?: { ShortName?: string }}

interface IFootprintManager_serialnumbers_gridComponentInParams {
  licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, search?: string, packagingId?: number, orderId?: number, orderLineNumber?: number}


class FootprintManager_serialnumbers_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_serialnumbers_gridComponent;
  entity: IFootprintManager_serialnumbers_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Lookup: null,
    packaging: null,
    status: null,
    material: null,
    material_group: null,
    material_description: null,
    lot: null,
    vendor_lot: null,
    project: null,
    net_weight: null,
    gross_weight: null,
    weight_uom: null,
    length: null,
    width: null,
    height: null,
    dimension_uom: null,
    net_volume: null,
    gross_volume: null,
    volume_uom: null,
    created_date: null,
    created_user: null,
    licenseplate_type: null,
    licenseplate: null,
    location: null,
    warehouse: null,
    notes: null,
  }



  constructor(
    grid: FootprintManager_serialnumbers_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_serialnumbers_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Lookup = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Lookup,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_group = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_group,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.vendor_lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendor_lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.net_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.gross_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.gross_weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.length,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.width,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.height,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.dimension_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.dimension_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.net_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_volume,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.gross_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.gross_volume,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.volume_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null,  'datetime', 'l, LT', null)
,
null
      );
    
    this.cells.created_user = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_user,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.licenseplate_type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.licenseplate_type,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_serialnumbers_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_serialnumbers_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      licenseplateIds:  $grid.inParams.licenseplateIds ,
      locationId:  $grid.inParams.locationId ,
      warehouseIds:  $grid.inParams.warehouseIds ,
      lotId:  $grid.inParams.lotId ?? $grid.filters.lot.control.value ,
      materialIds:  $grid.inParams.materialIds ,
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      archived:  $grid.inParams.archived ,
      fullTextSearch:  $grid.fullTextSearch ,
      textSearch:  $grid.inParams.search ,
      packagingId:  $grid.inParams.packagingId ?? $grid.filters.packaging.control.value ,
      orderId:  $grid.inParams.orderId ,
      orderLineNumber:  $grid.inParams.orderLineNumber ,
      ids:  null ,
    };
    const data = await this.$datasources.SerialNumbers.ds_serialnumbers_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_serialnumbers_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Lookup.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.material.displayControl as TextModel).text = $row.entity.Lot?.Material?.LookupCode;
    (this.cells.material_group.displayControl as TextModel).text = $row.entity.Lot?.Material?.MaterialGroup?.Name;
    (this.cells.material_description.displayControl as TextModel).text = $row.entity.Lot?.Material?.Description;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.vendor_lot.displayControl as TextModel).text = $row.entity.Lot?.VendorLot?.LookupCode;
    (this.cells.project.displayControl as TextModel).text = $row.entity.Lot?.Material?.Project?.LookupCode;
    (this.cells.net_weight.displayControl as TextModel).text = $row.entity.NetWeight?.toString();
    (this.cells.gross_weight.displayControl as TextModel).text = $row.entity.GrossWeight?.toString();
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.dimension_uom.displayControl as TextModel).text = $row.entity.DimensionsUom?.Short_name;
    (this.cells.net_volume.displayControl as TextModel).text = $row.entity.NetVolume?.toString();
    (this.cells.gross_volume.displayControl as TextModel).text = $row.entity.GrossVolume?.toString();
    (this.cells.volume_uom.displayControl as TextModel).text = $row.entity.VolumeUom?.Short_name;
    (this.cells.created_date.displayControl as TextModel).text = $row.entity.CreatedSysDateTime?.toString();
    (this.cells.created_user.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.licenseplate_type.displayControl as TextModel).text = $row.entity.LicensePlate?.Type?.Name;
    (this.cells.licenseplate.displayControl as TextModel).text = $row.entity.LicensePlate?.LookupCode;
    (this.cells.location.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Name;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Warehouse?.Name;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'Lookup' : {
        this.on_lookupcode_clicked();
        break;
      }
      case 'material' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'project' : {
        this.on_project_clicked();
        break;
      }
      case 'licenseplate' : {
        this.on_licenseplate_clicked();
        break;
      }
      case 'location' : {
        this.on_location_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_material_hub({materialId: $row.entity.Lot.Material.Id});
  }
  on_licenseplate_clicked(event = null) {
    return this.on_licenseplate_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_licenseplate_clickedInternal(
    $row: FootprintManager_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  $shell.FootprintManager.opensingle_licenseplate_hub({licenseplateId: $row.entity.LicensePlate.Id});
  }
  on_location_clicked(event = null) {
    return this.on_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_location_clickedInternal(
    $row: FootprintManager_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_location_hub({locationId: $row.entity.LicensePlate.Location.Id});
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_lot_hub({lotId: $row.entity.Lot.Id});
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_project_hub({projectId: $row.entity.Lot.Material.ProjectId});
  }
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootprintManager_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_serialnumber_hub({serialnumberId: $row.entity.Id});
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => SerialNumbers_serialnumbers_lots_dd_singleComponent),
    forwardRef(() => SerialNumbers_serialnumbers_packagings_dd_singleComponent),
  ],
  selector: 'FootprintManager-serialnumbers_grid',
  templateUrl: './FootprintManager.serialnumbers_grid.component.html'
})
export class FootprintManager_serialnumbers_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_serialnumbers_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_serialnumbers_gridComponentInParams = { licenseplateIds: [], locationId: null, warehouseIds: [], lotId: null, materialIds: [], projectId: null, ownerId: null, archived: null, search: null, packagingId: null, orderId: null, orderLineNumber: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Lookup: new GridHeaderModel(new HeaderStyles(null, null), 'Lookup', 'Serial number', false, false, null, false),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'packaging', 'Packaging', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       material: new GridHeaderModel(new HeaderStyles(null, null), 'material', 'Material', false, false, null, false),       material_group: new GridHeaderModel(new HeaderStyles(null, null), 'material_group', 'Material group', false, false, null, false),       material_description: new GridHeaderModel(new HeaderStyles(null, null), 'material_description', 'Material description', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       vendor_lot: new GridHeaderModel(new HeaderStyles(null, null), 'vendor_lot', 'Vendor lot', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       net_weight: new GridHeaderModel(new HeaderStyles(null, null), 'net_weight', 'Net weight', false, false, null, false),       gross_weight: new GridHeaderModel(new HeaderStyles(null, null), 'gross_weight', 'Gross weight', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'Weight UOM', false, false, null, false),       length: new GridHeaderModel(new HeaderStyles(null, null), 'length', 'Length', false, false, null, false),       width: new GridHeaderModel(new HeaderStyles(null, null), 'width', 'Width', false, false, null, false),       height: new GridHeaderModel(new HeaderStyles(null, null), 'height', 'Height', false, false, null, false),       dimension_uom: new GridHeaderModel(new HeaderStyles(null, null), 'dimension_uom', 'Dimension UOM', false, false, null, false),       net_volume: new GridHeaderModel(new HeaderStyles(null, null), 'net_volume', 'Net volume', false, false, null, false),       gross_volume: new GridHeaderModel(new HeaderStyles(null, null), 'gross_volume', 'Gross volume', false, false, null, false),       volume_uom: new GridHeaderModel(new HeaderStyles(null, null), 'volume_uom', 'Volume UOM', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created date', false, false, null, false),       created_user: new GridHeaderModel(new HeaderStyles(null, null), 'created_user', 'Created user', false, false, null, false),       licenseplate_type: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate_type', 'LP type', false, false, null, false),       licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate', 'LP', false, false, null, false),       location: new GridHeaderModel(new HeaderStyles(null, null), 'location', 'Location', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_serialnumbers_gridComponentRowModel[] = [];

  @Input('licenseplateIds') set $inParams_licenseplateIds(value: any) {
    this.inParams['licenseplateIds'] = value;
  }
  get $inParams_licenseplateIds(): any {
    return this.inParams['licenseplateIds'] ;
  }
  @Input('locationId') set $inParams_locationId(value: any) {
    this.inParams['locationId'] = value;
  }
  get $inParams_locationId(): any {
    return this.inParams['locationId'] ;
  }
  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }
  @Input('lotId') set $inParams_lotId(value: any) {
    this.inParams['lotId'] = value;
  }
  get $inParams_lotId(): any {
    return this.inParams['lotId'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('archived') set $inParams_archived(value: any) {
    this.inParams['archived'] = value;
  }
  get $inParams_archived(): any {
    return this.inParams['archived'] ;
  }
  @Input('search') set $inParams_search(value: any) {
    this.inParams['search'] = value;
  }
  get $inParams_search(): any {
    return this.inParams['search'] ;
  }
  @Input('packagingId') set $inParams_packagingId(value: any) {
    this.inParams['packagingId'] = value;
  }
  get $inParams_packagingId(): any {
    return this.inParams['packagingId'] ;
  }
  @Input('orderId') set $inParams_orderId(value: any) {
    this.inParams['orderId'] = value;
  }
  get $inParams_orderId(): any {
    return this.inParams['orderId'] ;
  }
  @Input('orderLineNumber') set $inParams_orderLineNumber(value: any) {
    this.inParams['orderLineNumber'] = value;
  }
  get $inParams_orderLineNumber(): any {
    return this.inParams['orderLineNumber'] ;
  }

  topToolbar = {
      adjust_inventory: new ToolModel(new ButtonModel('adjust_inventory', new ButtonStyles(null, null), false, false, false, 'Adjust quantity', 'icon-ic_fluent_box_arrow_left_20_regular', null)
    , false),
      move_inventory: new ToolModel(new ButtonModel('move_inventory', new ButtonStyles(null, null), false, false, false, 'Move inventory', 'icon-ic_fluent_box_arrow_up_20_regular', null)
    , false),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      distribute_total_weight: new ToolModel(new ButtonModel('distribute_total_weight', new ButtonStyles(null, null), false, false, false, 'Distribute total weight', 'icon-ic_fluent_scales_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    lot: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    packaging: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    lot: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['lot'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Lot', false, false),
    packaging: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['packaging'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Packaging', false, false),
  }

  //#region filters inParams
  cacheValueFor_$fields_lot_selector_inParams_licenseplateIds: number[];
  get $fields_lot_selector_inParams_licenseplateIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.licenseplateIds;
    
    if(!isEqual(this.cacheValueFor_$fields_lot_selector_inParams_licenseplateIds, expr)) {
      this.cacheValueFor_$fields_lot_selector_inParams_licenseplateIds = expr;
    }
    return this.cacheValueFor_$fields_lot_selector_inParams_licenseplateIds;
  }

  get $fields_lot_selector_inParams_locationId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.locationId;
    
    return expr;
  }

  cacheValueFor_$fields_lot_selector_inParams_warehouseIds: number[];
  get $fields_lot_selector_inParams_warehouseIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.warehouseIds;
    
    if(!isEqual(this.cacheValueFor_$fields_lot_selector_inParams_warehouseIds, expr)) {
      this.cacheValueFor_$fields_lot_selector_inParams_warehouseIds = expr;
    }
    return this.cacheValueFor_$fields_lot_selector_inParams_warehouseIds;
  }

  get $fields_lot_selector_inParams_lotId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.lotId;
    
    return expr;
  }

  cacheValueFor_$fields_lot_selector_inParams_materialIds: number[];
  get $fields_lot_selector_inParams_materialIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.materialIds;
    
    if(!isEqual(this.cacheValueFor_$fields_lot_selector_inParams_materialIds, expr)) {
      this.cacheValueFor_$fields_lot_selector_inParams_materialIds = expr;
    }
    return this.cacheValueFor_$fields_lot_selector_inParams_materialIds;
  }

  get $fields_lot_selector_inParams_projectId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.projectId;
    
    return expr;
  }

  get $fields_lot_selector_inParams_ownerId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.ownerId;
    
    return expr;
  }

  get $fields_lot_selector_inParams_archived(): boolean {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.archived;
    
    return expr;
  }

  get $fields_lot_selector_inParams_fullTextSearch(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.fullTextSearch;
    
    return expr;
  }

  get $fields_lot_selector_inParams_textSearch(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.search;
    
    return expr;
  }

  get $fields_lot_selector_inParams_orderId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.orderId;
    
    return expr;
  }

  get $fields_lot_selector_inParams_orderLineNumber(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.orderLineNumber;
    
    return expr;
  }

  cacheValueFor_$fields_packaging_selector_inParams_licenseplateIds: number[];
  get $fields_packaging_selector_inParams_licenseplateIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.licenseplateIds;
    
    if(!isEqual(this.cacheValueFor_$fields_packaging_selector_inParams_licenseplateIds, expr)) {
      this.cacheValueFor_$fields_packaging_selector_inParams_licenseplateIds = expr;
    }
    return this.cacheValueFor_$fields_packaging_selector_inParams_licenseplateIds;
  }

  get $fields_packaging_selector_inParams_locationId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.locationId;
    
    return expr;
  }

  cacheValueFor_$fields_packaging_selector_inParams_warehouseIds: number[];
  get $fields_packaging_selector_inParams_warehouseIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.warehouseIds;
    
    if(!isEqual(this.cacheValueFor_$fields_packaging_selector_inParams_warehouseIds, expr)) {
      this.cacheValueFor_$fields_packaging_selector_inParams_warehouseIds = expr;
    }
    return this.cacheValueFor_$fields_packaging_selector_inParams_warehouseIds;
  }

  get $fields_packaging_selector_inParams_lotId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.lotId ?? $grid.filters.lot.control.value;
    
    return expr;
  }

  cacheValueFor_$fields_packaging_selector_inParams_materialIds: number[];
  get $fields_packaging_selector_inParams_materialIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.materialIds;
    
    if(!isEqual(this.cacheValueFor_$fields_packaging_selector_inParams_materialIds, expr)) {
      this.cacheValueFor_$fields_packaging_selector_inParams_materialIds = expr;
    }
    return this.cacheValueFor_$fields_packaging_selector_inParams_materialIds;
  }

  get $fields_packaging_selector_inParams_projectId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.projectId;
    
    return expr;
  }

  get $fields_packaging_selector_inParams_ownerId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.ownerId;
    
    return expr;
  }

  get $fields_packaging_selector_inParams_archived(): boolean {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.archived;
    
    return expr;
  }

  get $fields_packaging_selector_inParams_fullTextSearch(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.fullTextSearch;
    
    return expr;
  }

  get $fields_packaging_selector_inParams_textSearch(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.search;
    
    return expr;
  }

  get $fields_packaging_selector_inParams_orderId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.orderId;
    
    return expr;
  }

  get $fields_packaging_selector_inParams_orderLineNumber(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.orderLineNumber;
    
    return expr;
  }

  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Serial numbers';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['lot']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_lot_changed();
      });

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      licenseplateIds:  $grid.inParams.licenseplateIds ,
      locationId:  $grid.inParams.locationId ,
      warehouseIds:  $grid.inParams.warehouseIds ,
      lotId:  $grid.inParams.lotId ?? $grid.filters.lot.control.value ,
      materialIds:  $grid.inParams.materialIds ,
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      archived:  $grid.inParams.archived ,
      fullTextSearch:  $grid.fullTextSearch ,
      textSearch:  $grid.inParams.search ,
      packagingId:  $grid.inParams.packagingId ?? $grid.filters.packaging.control.value ,
      orderId:  $grid.inParams.orderId ,
      orderLineNumber:  $grid.inParams.orderLineNumber ,
      ids:  null ,
    };
    try {
      const data = await this.$datasources.SerialNumbers.ds_serialnumbers_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_serialnumbers_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_serialnumbers_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_serialnumbers_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const hasOneSelectedRows = $grid.selectedRows.length === 1;
  $grid.topToolbar.adjust_inventory.control.readOnly = !hasOneSelectedRows;
  $grid.topToolbar.move_inventory.control.readOnly = !hasOneSelectedRows;
  
  $grid.topToolbar.adjust_inventory.hidden = (await $operations.FootprintManager.Disable_Inventory_Adjustment.isAuthorized());
  $grid.topToolbar.move_inventory.hidden = (await $operations.FootprintManager.Disable_Inventory_Movement.isAuthorized());
  $grid.topToolbar.distribute_total_weight.hidden = (await $operations.FootprintManager.Disable_SerialNumbers_DistributeWeight.isAuthorized());
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.adjust_inventory.control.readOnly = true;
  $grid.topToolbar.move_inventory.control.readOnly = true;
  
  $grid.topToolbar.separator2.hidden = true;
  $grid.topToolbar.distribute_total_weight.hidden = true;
  
  // Unhide distribute average weight function
  if (!await $operations.FootprintManager.Disable_SerialNumbers_DistributeWeight.isAuthorized()) {
      let fixedWeightCheck = (await $datasources.SerialNumbers.ds_serialnumbers_grid_check_fixed_weight.get($grid.inParams)).result;
  
      if (!$utils.isDefined(fixedWeightCheck) || fixedWeightCheck[0].FixedWeightSerials === 0) {
          $grid.topToolbar.separator2.hidden = false;
          $grid.topToolbar.distribute_total_weight.hidden = false;
      }
  }
  
  $grid.filters.lot.control.value = null;
  $grid.filters.packaging.control.value = null;
  
  $grid.topToolbar.adjust_inventory.hidden = (await $operations.FootprintManager.Disable_Inventory_Adjustment.isAuthorized());
  $grid.topToolbar.move_inventory.hidden = (await $operations.FootprintManager.Disable_Inventory_Movement.isAuthorized());
  $grid.topToolbar.distribute_total_weight.hidden = (await $operations.FootprintManager.Disable_SerialNumbers_DistributeWeight.isAuthorized());
  
  
  //
  //TODO:Remove the following comment if no longer required.
  //
  
  /* removed to fix bug when filtering by lot and packaging
  if ($utils.isDefined($grid.inParams.lotId)) {
      $grid.filters.lot.hidden = true;
  } else {
      const lotsPromise = $datasources.SerialNumbers.ds_handle_serialnumbers_lots_dd.getList($grid.inParams);
  
      lotsPromise.then(result => {
          if (result.result.length === 1) {
              $grid.filters.lot.control.value = result.result[0].LotId;
              $grid.filters.lot.control.readOnly = true;
          }
      })
  }
  
  if ($utils.isDefined($grid.inParams.packagingId)) {
      $grid.filters.packaging.hidden = true;
  } else {
      const packagingsPromise = $datasources.SerialNumbers.ds_handle_serialnumbers_packagings_dd.getList($grid.inParams);
  
      packagingsPromise.then(result => {
          if (result.result.length === 1) {
              $grid.filters.packaging.control.value = result.result[0].PackagingId;
              $grid.filters.packaging.control.readOnly = true;
          }
      })
  }
  */
  }
  on_adjust_inventory_clicked(event = null) {
    return this.on_adjust_inventory_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_adjust_inventory_clickedInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var licenseplateId = $grid.selectedRows[0].entity.LicensePlateId;
  
  
  if ($utils.isDefined(licenseplateId)) {
  
      for(let row of $grid.selectedRows){
          if(row.entity.LicensePlate.Type.Id === 5){
              throw new Error(`Unable to adjust license plates of type ${row.entity.LicensePlate.Type.Name}.`)
          }
      }
  
      const dialogResult = await $shell.FootprintManager.openinventory_adjustment_formDialog({
          licenseplateId: licenseplateId,
          lotId: $grid.selectedRows[0].entity.LotId,
          packagingId: $grid.selectedRows[0].entity.PackagingId,
          packagedAmount: 1,
          availablePackagedAmount: 1,
          serialnumberId: $grid.selectedRows[0].entity.Id
      })
      const userConfirmed = dialogResult.confirm;
      if (userConfirmed) {
          $grid.refresh()
      }
  
  
  }
  else {
  
      throw new Error('Unable to determine licenseplate from selected serial number.')
  }
  
  
  }
  on_move_inventory_clicked(event = null) {
    return this.on_move_inventory_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_move_inventory_clickedInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var licenseplateId = $grid.selectedRows[0].entity.LicensePlateId;
  
  
  if ($utils.isDefined(licenseplateId)) {
      for(let row of $grid.selectedRows){
          if(row.entity.LicensePlate.Type.Id === 5){
              throw new Error(`Unable to move license plates of type ${row.entity.LicensePlate.Type.Name}.`)
          }
      }
  
      const dialogResult = await $shell.FootprintManager.openinventory_and_licenseplate_move_formDialog({
          licenseplates: [{
              id: licenseplateId,
              content: [{
                  lotId: $grid.selectedRows[0].entity.LotId,
                  packagingId: $grid.selectedRows[0].entity.PackagingId,
                  packagedAmount: 1,
                  availablePackagedAmount: 1
              }],
          }],
          serialNumberIds: [$grid.selectedRows[0].entity.Id]
      });
  
      const userConfirmed = dialogResult?.confirm;
      if (userConfirmed) {
          await $grid.refresh()
      }
  
  }
  
  else {
  
      throw new Error('Unable to determine licenseplate from selected serial number.')
  }
  
  }
  on_average_weights_clicked(event = null) {
    return this.on_average_weights_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_average_weights_clickedInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try {
      // Get list of all serial numbers based on inputs
      const lotId = $grid.inParams.lotId ?? $grid.filters.lot.control.value;
      const packagingId = $grid.inParams.packagingId ?? $grid.filters.packaging.control.value;
  
      let missingFields: string[] = [];
      if (!$utils.isDefined(lotId)) { missingFields.push('lot'); }
      if (!$utils.isDefined(packagingId)) { missingFields.push('packaging'); }
  
      if ($utils.isDefined(missingFields)) {
          await $shell.FootprintManager.openErrorDialog('Missing required fields', `Please specify a ${(await $flows.Utilities.grammar_format_string_array_flow({ values: missingFields })).formattedValue} to distribute a new total weight.`);
          return;
      }
  
      const serialNumbers = (await $datasources.SerialNumbers.ds_serialnumbers_grid.get({
          licenseplateIds: $grid.inParams.licenseplateIds,
          locationId: $grid.inParams.locationId,
          warehouseIds: $grid.inParams.warehouseIds,
          lotId: lotId,
          materialIds: $grid.inParams.materialIds,
          projectId: $grid.inParams.projectId,
          ownerId: $grid.inParams.ownerId,
          archived: $grid.inParams.archived,
          fullTextSearch: $grid.fullTextSearch,
          packagingId: packagingId,
          orderId: $grid.inParams.orderId,
          orderLineNumber: $grid.inParams.orderLineNumber
      })).result;
  
  
      // Get new weight to distribute
      let result = await $shell.FootprintManager.openget_average_serial_weights_formDialog({
          serial_numbers: serialNumbers.map(sn => ({ id: sn.Id, lookup: sn.LookupCode, net_weight: sn.NetWeight, gross_weight: sn.GrossWeight })),
          weight_uom_id: $grid.rows[0]?.entity?.WeightUom?.Id
      }, 'modal');
  
      if (!$utils.isDefined(result.serial_numbers)) { return; }
  
      // Update serial numbers
      let updateResult = await $flows.SerialNumbers.update_serial_numbers_flow({
          serial_numbers: result.serial_numbers.map(sn => ({
              id: sn.id,
              properties: { NetWeight: sn.net_weight, GrossWeight: sn.gross_weight, WeightUomId: result.weight_uom_id }
          }))
      });
  
      if ($utils.isDefined(updateResult.reasons)) {
          throw new Error((await $flows.Utilities.grammar_format_string_array_flow({ values: updateResult.reasons })).formattedValue);
      }
  
      // Update license plate weights
      // Get License plates from serials (SerialNumbers)
      let licensePlateIds: number[] = [];
  
      if ($utils.isDefined($grid.inParams.licenseplateIds)) {
          licensePlateIds = $grid.inParams.licenseplateIds;
      } else {
          licensePlateIds.push(...(await $datasources.SerialNumbers.ds_serialnumbers_license_plates.get($grid.inParams)).result.map(lp => lp.LicensePlateId));
      }
  
      // Update license plate weights (Inventory)
      await $flows.Inventory.calculate_license_plates_weight_flow({
          license_plate_ids: licensePlateIds
      });
  
      await new Promise(result => setTimeout(result, 5000));
      await $grid.refresh();
  
  } catch (error) {
      let targetError = error;
      while ($utils.isDefined(targetError.error)) {
          targetError = targetError.error;
      }
  
      await $shell.FootprintManager.openErrorDialog('Error averaging weights', targetError.message);
  }
  
  
  /*********************************************
   * FUNCTIONS
  **********************************************/
  
  }
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let isExportConfirmed = await $shell.FootprintManager.openConfirmationDialog(
    'Confirm Export',
    'Export Serial Numbers?',
    'Confirm',
    'Cancel'
  );
  if (isExportConfirmed) {
    //Initialize
    const exportLimit = $settings.FootprintManager.ExcelExportLimit;
    const serverLimit = 5000;
    var wb = $event;
    var transactions = [];
    var totalRecords: number;
    // let dateFormat = $settings.FootprintManager.DateFormat ?? 'MM/dd/yyyy';
  
    const filters = {
      licenseplateIds: $grid.inParams.licenseplateIds,
      locationId: $grid.inParams.locationId,
      warehouseIds: $grid.inParams.warehouseIds,
      lotId: $grid.inParams.lotId ?? $grid.filters.lot.control.value,
      materialIds: $grid.inParams.materialIds,
      projectId: $grid.inParams.projectId,
      ownerId: $grid.inParams.ownerId,
      archived: $grid.inParams.archived,
      textSearch: $grid.inParams.search,
      fullTextSearch: $grid.fullTextSearch,
      packagingId: $grid.inParams.packagingId ?? $grid.filters.packaging.control.value,
      orderId: $grid.inParams.orderId,
      orderLineNumber: $grid.inParams.orderLineNumber,
    };
  
    // Get Selected Rows only.
    if ($grid.selectedRows.length > 0) {
      var serialNumbersId = [
        ...new Set($grid.selectedRows.map((o) => o.entity.Id)),
      ];
      totalRecords = $grid.selectedRows.length;
    } else {
      totalRecords = (
        await $datasources.SerialNumbers.ds_serialnumbers_grid.get(filters)
      ).totalCount;
    }
  
    if (totalRecords > exportLimit) {
      await $shell.Inventory.openInfoDialog(
        `Export limitation of ${exportLimit} exceeded`,
        `Excel will only export the first ${exportLimit} records`
      );
      totalRecords = exportLimit;
    }
  
    //////
  
    let data_info =
      await $datasources.SerialNumbers.ds_serialnumbers_grid.getList({
        ...filters,
        $top: serverLimit,
        ids: serialNumbersId,
      });
  
    let data: typeof data_info.result = [];
  
    //if results are more than 5000
    data = data.concat(data_info.result);
  
    let current: number = data_info.result?.length;
  
    while (current < totalRecords) {
      //only export up until the export limit and not the total count
  
      data_info = await $datasources.SerialNumbers.ds_serialnumbers_grid.getList({
        ...filters,
        $top: Math.min(totalRecords - current, serverLimit),
        ids: serialNumbersId,
        $skip: current,
      });
  
      if ($utils.isDefined(data_info?.result)) {
        data = data.concat(data_info.result);
        current = data?.length;
      } else {
        break;
      }
    }
  
    //////
  
    for (const datum of data) {
      transactions.push({
        Id: datum?.Id,
        Lookupcode: datum?.LookupCode,
        Packaging: datum?.Packaging?.ShortName,
        Status: datum?.Status?.Name,
        Material: datum?.Lot?.Material?.LookupCode,
        'Material group': datum?.Lot?.Material?.MaterialGroup?.Name,
        'Material Description': datum?.Lot?.Material?.Description,
        Lot: datum?.Lot?.LookupCode,
        'Vendor lot': datum?.Lot?.VendorLot?.LookupCode,
        Project: datum?.Lot?.Material?.Project?.LookupCode,
        'Net weight': datum?.NetWeight,
        'Gross weight': datum?.GrossWeight,
        'Weight uom': datum?.WeightUom?.Short_name,
        Length: datum?.Length,
        Width: datum?.Width,
        Height: datum?.Height,
        'Dimension uom': datum?.DimensionsUom?.Short_name,
        'Net volume': datum?.NetVolume,
        'Gross volume': datum?.GrossVolume,
        'Volume uom': datum?.VolumeUom?.Short_name,
        'Created date': datum?.CreatedSysDateTime,
        'Created user': datum?.CreatedSysUser,
        'LP type': datum?.LicensePlate?.Type?.Name,
        LP: datum?.LicensePlate?.LookupCode,
        Location: datum?.LicensePlate?.Location?.Name,
        Warehouse: datum?.LicensePlate?.Location?.Warehouse?.Name,
        Notes: datum?.Notes,
      });
    }
  
    var ws = $utils.excel.json_to_sheet(transactions);
  
    $utils.excel.book_append_sheet(wb, ws, 'SerialNumbersExport');
  } else {
    return;
  }
  
  }
  on_lot_changed(event = null) {
    return this.on_lot_changedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_changedInternal(
    $grid: FootprintManager_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.filters.packaging.control.value = null;
  
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'FootprintManager_serialnumbers_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
